import { Typography, Box } from "@mui/material";

export default function InstitutionDashboard() {
  return (
    <Box>
      <Typography variant="h4">Institution Dashboard</Typography>
      <Typography>Manage users, exams, and settings here.</Typography>
    </Box>
  );
}
